/*eslint-disable*/
import React from 'react'
import classNames from 'classnames'
import { NavLink, useLocation, useHistory } from 'react-router-dom'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'
import Drawer from '@material-ui/core/Drawer'
import Hidden from '@material-ui/core/Hidden'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { Icon } from '@iconify/react'
import { Grid, Collapse } from '@material-ui/core'
import { validateRole } from '../../utils/RoutesHelper'
import { useAuthentication } from '../../context/authenticationContext'
import Content from '../../components/Header/ContentNavBar'
import styles from '../../assets/jss/material-dashboard-react/layout/sidebarStyle'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import MenuOpenIcon from '@material-ui/icons/MenuOpen'
import { useOperation } from '../../context/operationsContext'
import BusinessIcon from '@mui/icons-material/Business'
import ROUTES from '../../routers/routes'
const useStyles = makeStyles(styles)

export const Sidebar = (props) => {
  const { pathname } = useLocation()
  const history = useHistory()
  const [selectedIndex, setSelectedIndex] = React.useState('')
  const classes = useStyles()
  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    return pathname[1] === routeName[1] ? true : false
  }
  const { color, logo, routes } = props
  const { UserRoles } = useAuthentication()
  const { operationID, operationLoanID } = useOperation()

  const validateChildToShow = (path) => {
    if (path?.includes('operaciones')) {
      if (operationID && operationLoanID) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }
  const validateTopToShow = (path) => {
    if (path?.includes('operaciones')) {
      return false
    } else {
      return true
    }
  }
  const handleClick = (index) => {
    if (selectedIndex === index) {
      setSelectedIndex('')
    } else {
      setSelectedIndex(index)
    }
  }
  const brand = (
    <div className={classes.logo}>
      <Grid container spacing={2} disableGutters={true}>
        <Grid item xs={12} sm={6}>
          <a
            href="#"
            onClick={() => history.push('/')}
            className={classNames(classes.logoLink)}
          >
            <div className={classes.logoImage}>
              <img src={logo} alt="logo" className={classes.img} />
            </div>
          </a>
        </Grid>
        {props.showMenuIcon && !props.open && (
          <Grid item xs={12} sm={6}>
            <div
              style={{ textAlign: 'right', cursor: 'pointer' }}
              onClick={() => props.handleDrawerToggleSideBar()}
            >
              <MenuOpenIcon color="primary" fontSize="large" />
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  )
  const links = (
    <List className={classes.list}>
      {routes?.map((prop, key) => {
        let activePro = ' '
        let listItemClasses
        listItemClasses = classNames({
          [' ' + classes[color]]: activeRoute(prop?.pathname),
        })
        const whiteFontClasses = classNames({
          [' ' + classes.whiteFont]: activeRoute(prop?.pathname),
        })
        return validateRole(prop.roles, UserRoles) ? (
          <NavLink
            to={
              prop.childrens &&
              props.childrens !== null &&
              prop.childrens.length > 0 &&
              validateTopToShow(prop?.pathname)
                ? '#'
                : prop?.pathname
            }
            className={activePro + classes.item}
            activeClassName="active"
            key={key}
          >
            <ListItem
              button
              className={listItemClasses}
              onClick={() => {
                handleClick(key)
              }}
            >
              {typeof prop.icon === 'string' ? (
                <Icon
                  className={classNames(classes.itemIcon, whiteFontClasses)}
                  icon={prop.icon}
                />
              ) : null}
              <ListItemText
                primary={prop?.name}
                className={classNames(classes.itemText, whiteFontClasses)}
                disableTypography={true}
              />
              {key === selectedIndex
                ? prop.childrens !== null &&
                  prop.childrens.length > 0 && <ExpandLess />
                : prop.childrens !== null &&
                  prop.childrens.length > 0 && <ExpandMore />}
            </ListItem>

            {props?.childrens !== null && prop.childrens?.length > 0 ? (
              <Collapse in={key === selectedIndex} timeout="auto" unmountOnExit>
                <List component="div" disablePadding style={{ paddingTop: 10 }}>
                  {prop.childrens && props.childrens !== null
                    ? prop.childrens.map((child, key) => {
                        let listItemClasseschild

                        listItemClasseschild = classNames({
                          [' ' + classes[color]]:
                            activeRoute(child.pathname) &&
                            pathname === child.pathname,
                        })

                        const whiteFontClasses = classNames({
                          [' ' + classes.whiteFont]:
                            activeRoute(child.pathname) &&
                            pathname === child.pathname,
                        })

                        return validateRole(child.roles, UserRoles) &&
                          validateChildToShow(child.pathname) ? (
                          <NavLink
                            to={`${
                              child.pathname?.includes('operaciones')
                                ? child.pathname
                                    .replace(':operationId', operationID)
                                    .replace(':bankOperation', operationLoanID)
                                : child.pathname
                            }`}
                            className={activePro + classes.item}
                            activeClassName={'active'}
                            key={key}
                          >
                            <ListItem
                              button
                              className={
                                classes.itemLinkapmSub + listItemClasseschild
                              }
                            >
                              {typeof child.icon === 'string' ? (
                                <Icon
                                  className={classNames(
                                    classes.itemIcon,
                                    whiteFontClasses,
                                  )}
                                  icon={child.icon}
                                />
                              ) : null}
                              <ListItemText
                                primary={child.name}
                                className={classNames(
                                  classes.itemText,
                                  whiteFontClasses,
                                )}
                                disableTypography={true}
                              />
                            </ListItem>
                          </NavLink>
                        ) : null
                      })
                    : null}
                </List>
              </Collapse>
            ) : null}
          </NavLink>
        ) : null
      })}
      {/* 
      <NavLink to={ROUTES.MIPYME.pathname} activeClassName="active">
        <ListItem button>
          <BusinessIcon
            style={{
              marginRight: '10px',
              color: '#014B96',
            }}
          />
          <ListItemText
            primary={'Registro MiPyme'}
            disableTypography={true}
            style={{
              color: '#111',
              fontSize: '14px',
              fontWeight: '300',
            }}
          />
        </ListItem>
      </NavLink> */}
    </List>
  )

  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={props.rtlActive ? 'left' : 'right'}
          open={props.open}
          classes={{
            paper: classNames(classes.drawerPaper, {
              [classes.drawerPaperRTL]: props.rtlActive,
            }),
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            {<Content />}
            {links}
          </div>
          <div />
        </Drawer>
      </Hidden>

      {/* <Hidden smDown implementation="css">
        <Drawer
          anchor={props.rtlActive ? 'right' : 'left'}
          variant={!props.showMenuIcon && 'permanent'}
          open={props.openSideBar}
          onClose={props.handleDrawerToggleSideBar}
          classes={{
            paper: classNames(
              props.openSideBar
                ? classes.drawerPaper
                : classes.drawerPaperUnShow,
              {
                [classes.drawerPaperRTL]: props.rtlActive,
              },
            ),
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>{links}</div>
          <div className={classes.background} />
        </Drawer>
      </Hidden> */}
    </div>
  )
}
